export default __webpack_public_path__ + "static/media/Postman.9927d954.png";